import { PropTypes } from "prop-types"
import ReactTooltip from "react-tooltip"

import { getTooltipPosition } from "./utils"

const Tooltip = ({ id, children, shouldOverridePosition, effect = "solid", place = "top" }) => (
  <ReactTooltip
    id={id}
    role="tooltip"
    effect={effect}
    place={place}
    overridePosition={shouldOverridePosition && getTooltipPosition}
  >
    <span className="oj-tooltip">{children}</span>
  </ReactTooltip>
)

Tooltip.propTypes = {
  children: PropTypes.node,
  effect: PropTypes.string,
  id: PropTypes.string.isRequired,
  place: PropTypes.string,
  shouldOverridePosition: PropTypes.bool
}

export default Tooltip
